import { render, staticRenderFns } from "./ds.vue?vue&type=template&id=7a5b95b8"
import script from "./ds.vue?vue&type=script&lang=js"
export * from "./ds.vue?vue&type=script&lang=js"
import style0 from "./ds.vue?vue&type=style&index=0&id=7a5b95b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports